import { Component, Input } from '@angular/core';

/* 
Usage:
    <vca-spinner [isLoading]="isBusy"></vca-spinner>
Attributes:
    [isLoading] - Required, boolean property to show/hide spinner
    [align]     - Optional, accepts left/right/center. Default center.
    [cssCls]    - Optional, custom css class can be configured
    [size]      - Optional, accepts sm/md/lg. Default lg.
 */

@Component({
    selector: 'vca-spinner',
    styles: [require('./vca-spinner.scss')],
    template: `
        <div *ngIf="isLoading" [ngClass]="getClass()">
            <div class="spinner spinner-{{size}}">Loading...</div>
        </div>
    `
})
export class VcaSpinner {
    @Input('isLoading') isLoading: boolean;
    @Input('align') align: string;
    @Input('cssCls') cssCls: string = '';
    @Input('size') size: string = 'lg';

    getClass() {
        let cls;
        switch (this.align) {
            case 'left':
                cls = 'left';
                break;
            case 'right':
                cls = 'right';
                break;
            default:
                cls = 'center';
                break;
        }
    return `${cls} ${this.cssCls}`;
    }
}



// WEBPACK FOOTER //
// ./src/common/vca-spinner/vca-spinner.component.ts